var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('award-write-component',{attrs:{"award-type":'awardWrite',"competitionKey":_vm.competitionKey}}),_c('award-selection-rule-modal'),_c('entry-search-modal')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }